import { Button, Row, Tag } from '@amzn/meridian';
import { isEmpty } from 'es-toolkit/compat';
import type { FC } from 'react';
import { FilterTypes, type SummaryFilter } from './filters.util';

export type ActiveFiltersProps = {
  filters: SummaryFilter[];
  onClearAll: () => void;
  onRemove: (filter: SummaryFilter) => void;
};

export const ActiveFilters: FC<ActiveFiltersProps> = ({ filters, onClearAll, onRemove }) => {
  const getFilterTag = (filter: SummaryFilter): string => {
    if (filter.type === FilterTypes.SearchQuery) {
      return `"${filter.name}"`;
    }
    return filter.name;
  };

  return (
    <Row alignmentVertical="center" minHeight={35} spacing="300">
      <Row alignmentVertical="center" spacing="200">
        {filters.map((filter) => (
          <span
            data-cy={`actve-filter-${filter.name}`}
            key={filter.name}
            title={filter.group ? `Filter for ${filter.group} = ${getFilterTag(filter)}` : `Filter for ${getFilterTag(filter)}`}
          >
            <Tag closeLabel="Remove filter" onClose={() => onRemove(filter)} type="neutral">
              {getFilterTag(filter)}
            </Tag>
          </span>
        ))}
      </Row>
      {!isEmpty(filters) && (
        <Button className="pb-0 pt-0" data-cy="reset-filters" onClick={onClearAll} type="link">
          Reset
        </Button>
      )}
    </Row>
  );
};
